import React from 'react';
import { Typography, Box, Button, Card } from '@material-ui/core';

import { Decimal } from 'shared/components/Decimal';

import { useStyles } from './styles';

interface InfoProps {
  price: number;
  rain: string;
  title: string;
  icon: () => JSX.Element;
  btnClick(): void;
  btnText: string;
  disable?: boolean;
}

const Info = (props: InfoProps) => {
  const classes = useStyles();

  const { price, rain, title, icon, btnText, btnClick, disable } = props;

  return (
    <Card className={classes.card}>
      <Box className={classes.icon}>{icon()}</Box>
      <Typography className={classes.blockTitle}>{title}</Typography>
      <Typography className={classes.blockValue}>
        $
        <Decimal thousSep="," fixed={2} className={classes.blockPrice}>
          {price}
        </Decimal>
      </Typography>
      <Typography className={classes.rain}>{rain}</Typography>
      <Box mb={3.5}>
        <Button variant="contained" className={classes.btn} onClick={btnClick} disabled={disable}>
          {btnText}
        </Button>
      </Box>
    </Card>
  );
};

Info.defaultProps = {
  disable: false,
};

export default Info;
